import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventAccommodationsCheck } from '@shared/hooks/useEventAccommodationsCheck';
import { useRouterHelper } from '@shared/core';
import { withWindow } from '@shared/utils/withWindow';

export const usePurchaseConfirmationLink = (eventHandle: string | undefined | null, isAffiliate: boolean = false) => {
  const { isGuestRoute } = useRouterHelper();

  const [accommodationsOnRegistryConfirmationV2Experiment] = useIsFeatureEnabled('accommodationsOnRegistryConfirmationV2Experiment', {
    skip: !isGuestRoute || isAffiliate,
  });
  const { hasVisibleAccommodationsEventPage, hasVisibleTravelEventPage, hasTravelAccommodationListings } = useEventAccommodationsCheck({
    eventHandle: eventHandle || '',
  });

  return (initialSuccessUrl: string): string => {
    if (!accommodationsOnRegistryConfirmationV2Experiment) {
      return initialSuccessUrl;
    }

    const baseUrl = withWindow(g => g.location.origin, '');
    const params = new URLSearchParams({
      pcId: '${purchaseContextId}',
      utm_medium: 'web',
      utm_source: 'confirmation_registry_purchase',
      utm_campaign: 'next_steps',
    });

    const path = hasVisibleAccommodationsEventPage
      ? `/${eventHandle}/accommodations`
      : hasVisibleTravelEventPage && hasTravelAccommodationListings
      ? `/${eventHandle}/travel`
      : `/${eventHandle}/registry/accommodations`;

    const url = new URL(path, baseUrl);
    url.search = params.toString();
    return url.toString();
  };
};
